"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "retailerById", {
    enumerable: true,
    get: ()=>retailerById
});
const _graphqlRequest = require("graphql-request");
const _retailerFragment = require("../fragments/retailer-fragment");
const retailerById = (0, _graphqlRequest.gql)`
    query retailerById($retailerId: ID!) {
        retailer(id: $retailerId) {
            ...retailerFragment
        }
    }
    ${_retailerFragment.RETAILER_FRAGMENT}
`;
